import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface SplashScreenProps {
  onComplete: () => void;
}

export const SplashScreen = ({ onComplete }: SplashScreenProps) => {
  const [phase, setPhase] = useState<"pulse" | "expand" | "exit">("pulse");

  useEffect(() => {
    const t1 = setTimeout(() => setPhase("expand"), 1500);
    const t2 = setTimeout(() => setPhase("exit"), 2800);
    const t3 = setTimeout(() => onComplete(), 3400);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [onComplete]);

  return (
    <AnimatePresence>
      {phase !== "exit" ? (
        <motion.div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-background"
          exit={{ y: "-100%", opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
        >
          <div className="flex items-center">
            <motion.span
              className="text-6xl font-bold text-primary select-none"
              style={{ fontFamily: "'Outfit', sans-serif" }}
              animate={
                phase === "pulse"
                  ? { scale: [1, 1.15, 1], opacity: [0.7, 1, 0.7] }
                  : { x: 0 }
              }
              transition={
                phase === "pulse"
                  ? { duration: 1, repeat: Infinity, ease: "easeInOut" }
                  : { duration: 0.5, ease: "easeInOut" }
              }
            >
              T
            </motion.span>

            <AnimatePresence>
              {phase === "expand" && (
                <motion.span
                  className="text-6xl font-bold text-primary select-none"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                  initial={{ opacity: 0, x: -20, width: 0 }}
                  animate={{ opacity: 1, x: 0, width: "auto" }}
                  transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
                >
                  ecly
                </motion.span>
              )}
            </AnimatePresence>
          </div>
        </motion.div>
      ) : (
        <motion.div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-background"
          initial={{ y: 0, opacity: 1 }}
          animate={{ y: "-100%", opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
        >
          <span
            className="text-6xl font-bold text-primary select-none"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Tecly
          </span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
